import React from "react";
import PageContainerAuth from "../../components/common/PageContainerAuth";
import MailingRuleEditSection from "../../components/pages/mailing-rules/edit/MailingRuleEditSection";
import { useParams } from "react-router-dom";


export function MailingRuleEdit() {
    const { uuid } = useParams();
    return (
        <PageContainerAuth section="mailings-mailing-edit" pageTitle="Modifier la configuration d'envoi" backDestination={`/mailing-rules/${uuid}`}>
            <MailingRuleEditSection/>
        </PageContainerAuth>
    );
}